import { computed } from 'vue'
import { gql } from 'graphql-tag'
import { useQuery } from '@vue/apollo-composable'

export function useTenantAccess() {
    const { result, loading, refetch } = useQuery(gql`
        query CurrentTenantAccess {
            currentTenantAccess {
                capabilities
            }
        }
    `, {}, { fetchPolicy: 'cache-and-network' })

    const capabilities = computed(() => result.value?.currentTenantAccess?.capabilities ?? [])
    const can = (capability) => capabilities.value.includes(capability)

    return { capabilities, can, loading, refetch }
}

export const entityCapability = (entityType, action) => `entities.${entityType}.${action}`
